import React from "react";
import Layout from "../../layout/main";
import WalletFinancialReports from "../../components/walletFinancialReports";

const WalletFinancialReportsPage = () => {
  return (
    <Layout>
      <WalletFinancialReports />
    </Layout>
  );
};

export default WalletFinancialReportsPage;
